import axios from 'axios';

export const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000';

const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default apiClient;